import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var BeneficiaryIndraService = /** @class */ (function () {
    function BeneficiaryIndraService() {
        this.beneficiaryNames$ = new BehaviorSubject({});
        this.currentBeneficiaryNames$ = this.beneficiaryNames$.asObservable();
        this.beneficiaryList$ = new BehaviorSubject({});
        this.currentBeneficiaryList$ = this.beneficiaryList$.asObservable();
        this.numberOfBeneficiaries$ = new BehaviorSubject({});
        this.currentNumberOfBeneficiaries$ = this.numberOfBeneficiaries$.asObservable();
        this.passengers$ = new BehaviorSubject({});
        this.currentPassengers$ = this.passengers$.asObservable();
        this.paxSalutations$ = new BehaviorSubject({});
        this.currentPaxSalutations$ = this.paxSalutations$.asObservable();
    }
    BeneficiaryIndraService.prototype.setBeneficiaryNames = function (beneficiaryNames) {
        this.beneficiaryNames$.next(beneficiaryNames);
    };
    BeneficiaryIndraService.prototype.setBeneficiaryList = function (beneficiaryList) {
        this.beneficiaryList$.next(beneficiaryList);
    };
    BeneficiaryIndraService.prototype.setNumberOfBeneficiaries = function (number) {
        this.numberOfBeneficiaries$.next(number);
    };
    BeneficiaryIndraService.prototype.setPassengers = function (passengers) {
        this.passengers$.next(passengers);
    };
    BeneficiaryIndraService.prototype.setPaxSalutations = function (paxSalutations) {
        this.paxSalutations$.next(paxSalutations);
    };
    BeneficiaryIndraService.prototype.INDRA_formatCapitalization = function (salutation) {
        return salutation.charAt(0).toUpperCase() + salutation.slice(1).toLowerCase();
    };
    BeneficiaryIndraService.prototype.INDRA_formatPaxSalutations = function (rawPaxSalutations) {
        var salutationsArray = [];
        rawPaxSalutations.forEach(function (salutation) {
            var splitted = salutation.toUpperCase().split(";");
            salutationsArray.push({
                salutation: splitted[0],
                typePax: splitted[1],
                gender: splitted[2],
            });
        });
        return salutationsArray;
    };
    BeneficiaryIndraService.prototype.INDRA_getTypePaxFromSalutation = function (paxSalutations, salutation) {
        var returnable = "";
        paxSalutations.forEach(function (sal) {
            if (sal.salutation.toUpperCase() == salutation.toUpperCase()) {
                returnable = sal.typePax;
            }
        });
        return returnable;
    };
    BeneficiaryIndraService.prototype.INDRA_getSalutationFromTypePax = function (paxSalutations, typePax) {
        var returnable = "";
        paxSalutations.forEach(function (sal) {
            if (sal.typePax.toUpperCase() == typePax.toUpperCase()) {
                returnable = sal.salutation;
            }
        });
        return returnable;
    };
    BeneficiaryIndraService.prototype.INDRA_getSalutationFromGender = function (paxSalutations, gender) {
        var returnable = "";
        paxSalutations.forEach(function (sal) {
            if (sal.gender.toUpperCase() == gender.toUpperCase()) {
                returnable = sal.salutation;
            }
        });
        return returnable;
    };
    BeneficiaryIndraService.prototype.INDRA_getGenderFromSalutation = function (paxSalutations, salutation) {
        var returnable = "";
        paxSalutations.forEach(function (sal) {
            if (sal.salutation.toUpperCase() == salutation.toUpperCase()) {
                returnable = sal.gender;
            }
        });
        return returnable;
    };
    BeneficiaryIndraService.ngInjectableDef = i0.defineInjectable({ factory: function BeneficiaryIndraService_Factory() { return new BeneficiaryIndraService(); }, token: BeneficiaryIndraService, providedIn: "root" });
    return BeneficiaryIndraService;
}());
export { BeneficiaryIndraService };
